import { render, staticRenderFns } from "./consignment.vue?vue&type=template&id=30fbc904&scoped=true&"
import script from "./consignment.js?vue&type=script&lang=js&"
export * from "./consignment.js?vue&type=script&lang=js&"
import style0 from "./consignment.scss?vue&type=style&index=0&id=30fbc904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fbc904",
  null
  
)

export default component.exports